module.exports = __webpack_public_path__ + "static/media/doc-pencil-icon.1cf20499.svg";